export default __webpack_public_path__ + "static/media/business-info-2x.0e416480.png";